import type { AutoUltrareviewMode } from './schema';

export const DEFAULT_AUTO_ULTRAREVIEW_MODE: AutoUltrareviewMode = 'disabled';
